import type { IAwsRecord } from '../shared/storable';
import { TypeNames } from '../shared/storable';

export const InvitationStatus = {
  Pending: 'pending',
  Accepted: 'accepted',
  Expired: 'expired',
  Revoked: 'revoked',
} as const;

export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus];

export const InvitationDeliveryStatus = {
  Pending: 'pending',
  Sent: 'sent',
  Failed: 'failed',
} as const;

export type InvitationDeliveryStatus = (typeof InvitationDeliveryStatus)[keyof typeof InvitationDeliveryStatus];

export interface IInvitation extends IAwsRecord {
  email: string;
  organizationID: string;
  orgName?: string;
  status: InvitationStatus;
  token?: string;
  invitedBy: string;
  inviterName?: string;
  expiresAt: number;
  deliveryStatus?: InvitationDeliveryStatus;
  lastDeliveryAttemptAt?: number;
  deliveredAt?: number;
  lastDeliveryError?: string | null;
  acceptedAt?: number;
  revokedAt?: number;
}

export const DEFAULT_INVITATION_TYPE_NAME = TypeNames.Invitation;
